import React from 'react';
import IconBase from './IconBase';

const ExampleIcon = props => {
    return (
        <IconBase {...props}>
            <path d="M7.8,10.5c-0.2,0-0.4-0.1-0.5-0.2C7.1,10.1,7,10,7,9.8c0-0.2,0.1-0.4,0.2-0.5C7.4,9.1,7.5,9,7.8,9h8.5 c0.2,0,0.4,0.1,0.5,0.2C16.9,9.4,17,9.5,17,9.8c0,0.2-0.1,0.4-0.2,0.5c-0.1,0.1-0.3,0.2-0.5,0.2H7.8z"/>
            <path d="M7.8,13.5c-0.2,0-0.4-0.1-0.5-0.2C7.1,13.1,7,13,7,12.8c0-0.2,0.1-0.4,0.2-0.5C7.4,12.1,7.5,12,7.8,12h8.5 c0.2,0,0.4,0.1,0.5,0.2c0.1,0.1,0.2,0.3,0.2,0.5c0,0.2-0.1,0.4-0.2,0.5c-0.1,0.1-0.3,0.2-0.5,0.2H7.8z"/>
            <path d="M7.8,16.5c-0.2,0-0.4-0.1-0.5-0.2C7.1,16.1,7,16,7,15.8c0-0.2,0.1-0.4,0.2-0.5C7.4,15.1,7.5,15,7.8,15h4.5 c0.2,0,0.4,0.1,0.5,0.2c0.1,0.1,0.2,0.3,0.2,0.5c0,0.2-0.1,0.4-0.2,0.5c-0.1,0.1-0.3,0.2-0.5,0.2H7.8z"/>
            <path d="M20.5,3.5c-0.3-0.3-0.6-0.5-1-0.5h-15c-0.4,0-0.8,0.2-1,0.5S3,4.1,3,4.5v15c0,0.4,0.2,0.8,0.5,1s0.6,0.5,1,0.5 h15c0.4,0,0.8-0.2,1-0.5s0.5-0.6,0.5-1v-15C21,4.1,20.8,3.8,20.5,3.5z M19.5,19.5h-15V6h15V19.5z"/>
        </IconBase>
    )
}

export default ExampleIcon;